module.exports = __webpack_public_path__ + "static/media/pdp_postcardHover.189961be.jpg";